
<app-side-bar *ngIf="visible"></app-side-bar>
<app-nav-bar *ngIf="visible"></app-nav-bar>
<router-outlet></router-outlet>